export enum Zone {
  DAY = 'day',
  NIGHT = 'night',
  BOTH = 'both',
}
